document.addEventListener('alpine:init', () => {
  Alpine.data('ProductRewardsBar', () => ({
    contentHTML: null,
    init() {
      window.addEventListener(
        'shapes:cart:afteradditem',
        this.onCartUpdate.bind(this)
      );
      window.addEventListener(
        'shapes:cart:cartqtychange',
        this.onCartUpdate.bind(this)
      );
      window.addEventListener(
        'shapes:cart:update',
        this.onCartUpdate.bind(this)
      );
    },
    async onCartUpdate() {
      const sectionId = this.$root.dataset.sectionId;

      if (!sectionId) return;

      const updatedSection = await freshHTML(
        getURLWithParams(window.location.pathname, {
          section_id: sectionId,
        })
      );

      const updatedRoot = querySelectorInHTMLString(
        '[data-product-rewards-bar]',
        updatedSection
      );

      if (!updatedRoot) return;

      const updatedContent = updatedRoot.querySelector('[data-content]');

      if (updatedContent) {
        this.contentHTML = updatedContent.innerHTML;
      }
    },
  }));
});
